import { Church, Mail, Users, MessageCircle } from "lucide-react";

export function Footer() {
  return (
    <footer className="w-full border-t border-border bg-card py-12">
      <div className="px-4 md:px-10 max-w-[1280px] mx-auto flex flex-col md:flex-row justify-between items-start md:items-center gap-8">
        <div>
          <div className="flex items-center gap-2 text-foreground mb-4">
            <Church className="size-5 text-primary" />
            <h2 className="text-xl font-display font-bold">JC Ministry</h2>
          </div>
          <p className="text-muted-foreground text-sm">
            <span className="text-primary font-medium">J</span>esus <span className="text-primary font-medium">C</span>hrist · <span className="text-primary font-medium">J</span>esus <span className="text-primary font-medium">C</span>ommunity · <span className="text-primary font-medium">J</span>ubilee in the <span className="text-primary font-medium">C</span>ity
          </p>
          <p className="text-muted-foreground text-xs mt-1">
            Serving international students in Philadelphia
          </p>
        </div>

        <div className="flex gap-4">
          <a
            href="mailto:hello@jcministry.org"
            className="size-10 rounded-full bg-secondary flex items-center justify-center text-muted-foreground hover:bg-primary hover:text-primary-foreground transition-all"
            aria-label="이메일"
          >
            <Mail className="size-5" />
          </a>
          <a
            href="#"
            className="size-10 rounded-full bg-secondary flex items-center justify-center text-muted-foreground hover:bg-primary hover:text-primary-foreground transition-all"
            aria-label="커뮤니티"
          >
            <Users className="size-5" />
          </a>
          <a
            href="#"
            className="size-10 rounded-full bg-secondary flex items-center justify-center text-muted-foreground hover:bg-primary hover:text-primary-foreground transition-all"
            aria-label="문의"
          >
            <MessageCircle className="size-5" />
          </a>
        </div>
      </div>

      <div className="px-4 md:px-10 max-w-[1280px] mx-auto mt-8 pt-8 border-t border-border text-center md:text-left">
        <p className="text-muted-foreground text-xs">
          &copy; {new Date().getFullYear()} JC Ministry. All rights reserved.
        </p>
      </div>
    </footer>
  );
}
